import React, { useState } from "react";
import {
    Menu,
    MenuItem,
    Button,
    Typography,
    Box,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { isLightColor } from "../../Leads/DynamicFormFields/helper.ts";
import { EllipsisWithTooltip } from "../Tables/TableV1.tsx";
interface StatusDropdownProps {
    options: any[]; // status or substatus array
    value?: any; // selected status/substatus
    onChange: (option: any) => void;
    buttonLabel?: string;
    labelKey?: string;
    valueKey?: string;
    groupKey?: string; // for grouping, e.g. type_of_status
    iconKey?: string; // key for icon component, e.g. 'icon'
    disabled?: Boolean
}

const StatusDropdown: React.FC<StatusDropdownProps> = ({
    options,
    value,
    onChange,
    buttonLabel = "Select",
    labelKey = "status_name",
    valueKey = "status_id",
    groupKey = "type_of_status",
    iconKey = "icon",
    disabled = false
}) => {
    const [anchorEl, setAnchorEl] = useState < null | HTMLElement > (null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => setAnchorEl(null);
    const handleSelect = (option: any) => {
        onChange(option);
        handleClose();
    };
    return (
        <>
            <Button
                onClick={disabled ? null : handleClick}
                variant="contained"
                size="small"
                endIcon={<ExpandMoreIcon />}
                sx={{
                    backgroundColor: value?.colorCode ?? "#e5e5e5",
                    color: isLightColor(value?.colorCode ?? "#e5e5e5") ? "black" : "white",
                    borderRadius: "25px",
                    textTransform: "none",
                    padding: "4px 16px",
                    boxShadow: "none",
                    "&:hover": {
                        backgroundColor: value?.colorCode ?? "#d5d5d5",
                        boxShadow: "none"
                    }
                }}
            >
                {value ? <EllipsisWithTooltip text={value[labelKey]} /> : <EllipsisWithTooltip text={buttonLabel} />}
            </Button>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                PaperProps={{ style: { maxHeight: 400, width: 280 } }}
            >
                {options?.map((option) => {
                    const isSelected = value?.[valueKey] === option[valueKey];
                    return (
                        <MenuItem
                            key={option[valueKey]}
                            selected={isSelected}
                            onClick={() => handleSelect(option)}
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                paddingY: 1,
                                paddingX: 1.5,
                                borderRadius: "8px",
                                "&.Mui-selected": {
                                    backgroundColor: "#eef3ff !important",
                                    fontWeight: 600
                                }
                            }}
                        >
                            <Box
                                sx={{
                                    width: 12,
                                    height: 12,
                                    borderRadius: "50%",
                                    backgroundColor: option?.colorCode ?? "#999",
                                    border: "1px solid #ccc",
                                    flexShrink: 0
                                }}
                            />
                            <Typography
                                variant="body2"
                                sx={{
                                    flexGrow: 1,
                                    whiteSpace: "normal",       // allow multi-line
                                    wordBreak: "break-word"      // break long words
                                }}
                            >
                                {option[labelKey]}
                            </Typography>
                            {isSelected && (
                                <CheckCircleIcon
                                    fontSize="small"
                                    color="success"
                                    sx={{ ml: "auto" }}
                                />
                            )}
                        </MenuItem>
                    );
                })}
            </Menu>
        </>
    );
};

export default StatusDropdown;